/**
 * Home 2024 Announcement Banner
 *
 * @author BarrelNY
 * @since 35.0.0
 */

import Flickity from '@lib/flickity-fade-ios15-patch'
import throttle from "@modules/main/throttle/throttle"

class SeriesCarousel {
  constructor(el) {
    this.el = el
    
    this.initCarousel()
  }

  initCarousel() {
    return new Flickity(this.el, {
      cellAlign: 'center',
      prevNextButtons: true,
      autoPlay: true,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      fade: true,
      contain: true
    })
  }
}

export default el => new SeriesCarousel(el)

